import api from './api';
import { CITY } from './endpoints';

const get = () => api.get(`${CITY}/`);

export default {
  get,
};
